module.exports = __webpack_public_path__ + "static/media/icon1.e8ad4d49.png";